// extracted by mini-css-extract-plugin
module.exports = {"box":"About_box_J0sYI","firstScreen":"About_firstScreen_3bax1","slogan":"About_slogan_28GIx","secondScreen":"About_secondScreen_u-0VX","text":"About_text_aqm8E"};